<template>
  <v-app id="app" fill-height fluid :class="isManagementURL() ? 'management-background' : ''">
    <NavBar v-if="!isLogin" />
    <v-main :class="isLogin ? 'mb-0' : 'mb-4'" fill-height fluid>
      <BreadCrumb
        v-if="!isLogin"
        :style="isHome? 'visibility:hidden':''"
      />
      <Snackbar />
      <v-container
       :class="isLogin ? 'auth-shell' : ''"
       :fill-height="isLogin? true:false"
       :fluid="isLogin? true:false"
      >
        <PageTitle v-if="!isLogin" />
        <router-view></router-view>
      </v-container>
    </v-main>
    <SiteFooter v-if="!isLogin" />
  </v-app>
</template>

<script>
import SiteFooter from "./components/layouts/SiteFooter";
import NavBar from "./components/layouts/NavBar";
import BreadCrumb from "./components/layouts/BreadCrumb";
import Snackbar from "./components/layouts/Snackbar";
import PageTitle from "./components/layouts/PageTitle";
export default {
  components: {Snackbar, SiteFooter, NavBar, BreadCrumb, PageTitle },
  created: function() {
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  },
  computed: {
    isLogin() {
       return this.$route.name === 'Login' || this.$route.name === 'Activate Account'
    },
    isHome() {
       return this.$route.name === 'Home'
    }
  },
  methods:{
    isManagementURL() {
      if(this.$route.path.includes("manage/") || this.$route.path.includes("direction/") ) return true;
      else return false;
    },
  }
};
export function compilationdate(){
  return document.documentElement.dataset.buildTimestampUtc;
}
</script>
<style lang="scss">
#app {
  background-color: var(--v-background-base);
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.auth-shell.container {
  max-width: 100vw !important;
  width: 100vw !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
